module.exports = __webpack_public_path__ + "static/media/pay-stripe-off.6b699106.png";